import { GoogleMapsLibrary } from '~/framework/helpers/google/google-maps-library';

import clusterPin from "./cluster-blue.svg";
import { type Icons } from './interfaces';
import accommodation from "./marker-accommodation.svg";
import blackPin from "./marker-black.svg";
import bluePin from "./marker-blue.svg";
import bluePinDark from "./marker-blue-dark.svg";
import building from "./marker-building.svg";
import food from "./marker-food.svg";
import health from "./marker-health.svg";
import leisure from "./marker-leisure.svg";
import localBusiness from "./marker-local-business.svg";
import location from "./marker-location.svg";
import locationFilled from "./marker-location-filled.svg"
import shopping from "./marker-shopping.svg";
import transport from "./marker-transport.svg";
import utilities from "./marker-utilities.svg";
import whitePin from "./marker-white.svg";

function dynamicIcon (color: string): string {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_46261_6263)">
            <path d="M30.5 1.08936C24.913 1.14608 19.5708 3.39071 15.62 7.34152C11.6692 11.2923 9.42458 16.6345 9.36786 22.2215C9.36786 33.7679 28.975 57.2965 29.8464 58.3858L30.5 59.0394L31.1536 58.3858C32.025 57.2965 51.6321 33.7679 51.6321 22.2215C51.6321 19.4464 51.0855 16.6984 50.0236 14.1346C48.9616 11.5707 47.405 9.24112 45.4427 7.27882C43.4804 5.31652 41.1508 3.75993 38.5869 2.69794C36.0231 1.63595 33.2751 1.08936 30.5 1.08936Z" fill="#2A6DF6"/>
            <path d="M30.5 60.7821L28.975 59.0393C28.1036 57.95 8.27856 34.2036 8.27856 22.2214C8.27856 16.3279 10.6197 10.6758 14.7871 6.50851C18.9544 2.34118 24.6065 0 30.5 0C36.3935 0 42.0456 2.34118 46.2129 6.50851C50.3802 10.6758 52.7214 16.3279 52.7214 22.2214C52.7214 33.7679 34.2036 56.425 32.025 59.0393L30.5 60.7821ZM30.5 2.17857C25.1843 2.17857 20.0863 4.29022 16.3276 8.04899C12.5688 11.8078 10.4571 16.9057 10.4571 22.2214C10.4571 31.1536 23.5286 49.0179 30.5 57.5143C37.4714 49.0179 50.5429 30.9357 50.5429 22.2214C50.5429 16.9057 48.4312 11.8078 44.6724 8.04899C40.9137 4.29022 35.8157 2.17857 30.5 2.17857Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_46261_6263">
                <rect width="61" height="61" fill="white"/>
            </clipPath>
        </defs>
    </svg>
    `).replace('2A6DF6', color)
}

const colours: Record<string, string> = {
    stocklandAzureBlue        : "2A6DF6",
    stocklandAzureBlueDark    : "1D5BC5",
    stocklandAzureBlueMuted    : "52ABE8",
    stocklandDarkBlue        : "152A65",
    stocklandDarkBlueMuted    : "52ABE8",
    stocklandDarkGreen        : "1F551D",
    stocklandDarkGreenMuted    : "80E172",
    stocklandGreen        : "1F551D",
    stocklandGreenMuted  : "80E172",
    stocklandMutedGreen        : "1F551D",
    stocklandMutedGreenMuted  : "80E172",
    stocklandOrange       : "9A4400",
    stocklandOrangeMuted : "F78F4D",
    stocklandPastelBlue   : "152A65",
    stocklandPastelBlueMuted : "52ABE8",
    stocklandPastelOrange       : "9A4400",
    stocklandPastelOrangeMuted : "F78F4D",
    stocklandPastelPink         : "79305A",
    stocklandPastelPinkMuted   : "F27FB2",
    stocklandPastelPurple       : "431465",
    stocklandPastelPurpleMuted : "B591DB",
    stocklandPink         : "79305A",
    stocklandPinkMuted   : "F27FB2",
    stocklandPurple       : "431465",
    stocklandPurpleMuted : "B591DB",
}

export const initializeIcons = async (): Promise<Icons> => {
    await GoogleMapsLibrary.mapsLibrary();
	
    const icons: Icons = {
        accommodation: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: accommodation,
        },
        building: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: building,
        },
        food: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: food,
        },
        health: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: health,
        },
        leisure: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: leisure,
        },
        localBusiness: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: localBusiness,
        },
        location: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: location,
        },
        shopping: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: shopping,
        },
        transport: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: transport,
        },
        utilities: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: utilities,
        },
        blackPin: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: blackPin,
        },
        bluePin: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: bluePin,
        },
        bluePinDark: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: bluePinDark,
        },
        clusterPin: {
            anchor: new google.maps.Point(36, 36),
            origin: new google.maps.Point(0, 0),
            url: clusterPin,
        },
        whitePin: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: whitePin,
        },
        locationPin: {
            anchor: new google.maps.Point(20, 54),
            origin: new google.maps.Point(0, 0),
            url: locationFilled,
        },
    };

    // This could be dynamic, or it could go through tailwind config (see ColoursDocumentation) and add every brand colour
    for (const key of Object.keys(colours)) {
        icons[key] = {
            anchor: new google.maps.Point(30, 61),
            origin: new google.maps.Point(0, 0),
            url: dynamicIcon(colours[key]),
        }
    }
    
    return icons;
}